import React, { Component } from 'react';
import './schedule.css';
import logo from './logo.png';
import { Button } from '@fluentui/react-components';
import { 
  Navigation24Regular,
  SearchInfoFilled,
  OrganizationFilled,
  ScalesFilled,
  MailFilled,
  SearchFilled,
  PeopleFilled,
  CalendarMonthFilled
} from '@fluentui/react-icons';
import NavBar from './NavBar';

interface ScheduleProps {}

interface ScheduleState {
  isMenuOpen: boolean;
  isProductsMenuOpen: boolean;
  isSolutionsMenuOpen: boolean;
}

class Schedule extends Component<ScheduleProps, ScheduleState> {
  constructor(props: ScheduleProps) {
    super(props);
    this.state = {
      isMenuOpen: false,
      isProductsMenuOpen: false,
      isSolutionsMenuOpen: false
    };
  }

  toggleMenu = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };

  toggleProductsMenu = () => {
    this.setState({ isProductsMenuOpen: !this.state.isProductsMenuOpen });
  };

  closeProductsMenu = () => {
    this.setState({ isProductsMenuOpen: false });
  };

  toggleSolutionsMenu = () => {
    this.setState({ isSolutionsMenuOpen: !this.state.isSolutionsMenuOpen });
  };

  closeSolutionsMenu = () => {
    this.setState({ isSolutionsMenuOpen: false });
  };

  scrollToSection = (sectionId: string) => {
    window.location.href = `/#${sectionId}`;
  };

  render() {
    return (
      <div className="schedule-page">
        {/* Top Navigation */}
        <NavBar />

        {/* Hero Section */}
        {/* Hero Section */}
        <section className="schedule-hero-section">
          <div className="schedule-hero-content">
            <CalendarMonthFilled className="schedule-hero-icon" />
            <h1 className="schedule-hero-title">Schedule a Demo</h1>
            <p className="schedule-hero-subtitle">
              See our solutions in action. Book a personalized demo with our team and discover how 
              Meta-365 can transform your business operations.
            </p>
          </div>
        </section>

        {/* Booking Section */}
        <section className="schedule-booking-section">
          <div className="schedule-container">
            <div className="schedule-booking-wrapper">
              <div className="schedule-booking-header">
                <h2>Choose Your Preferred Time</h2>
                <p>Select a convenient time slot for your demo. Our team will walk you through our solutions 
                and answer all your questions.</p>
              </div>

              <div className="schedule-booking-content">
                <div className="booking-info-card">
                  <h3>What to Expect</h3>
                  <ul>
                    <li><strong>Duration:</strong> 30-45 minutes</li>
                    <li><strong>Format:</strong> Online meeting via Microsoft Teams</li>
                    <li><strong>Coverage:</strong> Product overview, Q&A, and custom use cases</li>
                    <li><strong>Follow-up:</strong> Detailed proposal and next steps</li>
                  </ul>
                </div>

                <div className="booking-iframe-wrapper">
<iframe src='https://outlook.office.com/book/META365BOOKING@e-study.gr/?ismsaljsauthenabled' width='100%' height='100%' scrolling='yes' style={{border:0}}></iframe>

                  <div className="booking-fallback">
                    <p>Having trouble with the booking form?</p>
                    <a 
                      href="https://outlook.office.com/book/META365Bookingforademo@e-study.gr/?ismsaljsauthenabled" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="booking-direct-link"
                    >

                        <a href='https://outlook.office.com/book/META365Bookingforademo@e-study.gr/?ismsaljsauthenabled'>Schedule online</a>
                      <Button appearance="primary" size="large">
                        Open Booking Page Directly
                      </Button>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="schedule-info-sidebar">
              <div className="schedule-info-card">
                <h3>Before Your Demo</h3>
                <p>To make the most of your demo session:</p>
                <ul>
                  <li>Prepare questions about your specific needs</li>
                  <li>Have stakeholders join if desired</li>
                  <li>Review <a href="/the-challenge">the challenge we solve</a></li>
                  <li>Check your Microsoft Teams setup</li>
                </ul>
              </div>

              <div className="schedule-contact-card">
                <h3>Need Help?</h3>
                <p>If you have questions before booking or need a custom time slot, contact us directly.</p>
                <Button 
                  appearance="outline" 
                  size="medium"
                  onClick={() => window.location.href = '/contactus'}
                >
                  Contact Us
                </Button>
              </div>

              <div className="schedule-features-card">
                <h3>Why Meta-365?</h3>
                <ul>
                  <li>✓ Built for Microsoft 365</li>
                  <li>✓ No complex setup required</li>
                  <li>✓ Proven ROI with real customers</li>
                  <li>✓ Ongoing support & training</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="footer">
          <div className="container">
            <div className="footer-grid">
              <div className="footer-column">
                <h4>Products</h4>
                <ul>
                  <li><a href="/solutions/pentities">pEntities</a>
                    <ul className="footer-subnav">
                      <li><a href="/solutions/automation">Automation Module</a></li>
                      <li><a href="/solutions/ticketing">Ticketing Module</a></li>
                      <li><a href="/solutions/hr-template">HR Module</a></li>
                      <li><a href="/solutions/case-management">Legal Module</a></li>
                      <li><a href="/solutions/hr-hub">Employee Module</a></li>
                    </ul>
                  </li>
                  <li><a href="/solutions/pshareemail">PShareEmail</a></li>
                  <li><a href="/solutions/docsearch">DocSearch Tool</a></li>
                  <li><a href="/solutions/searchassistant">Search Assistant</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Company</h4>
                <ul>
                  <li><a href="/about">About Us</a></li>
                  <li><a href="/get-started">Get Started</a></li>
                  <li><a href="/contactus">Contact Us</a></li>
                  <li><a href="/plans-pricing">Plans & Pricing</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Support</h4>
                <ul>
                  <li><a href="/knowledge">Knowledge Base</a></li>
                  <li><a href="/technical-support">Technical Support</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Contact Us</h4>
                <div className="footer-office">
                  <p className="office-name">Athens Office</p>
                  <p>365 Kifisias Avenue, Kifisia, 14561</p>
                  <p>Ground Floor, Inside the Arcade</p>
                  <p>Tel: (+30)-210-260-3764</p>
                </div>
                <div className="footer-office">
                  <p className="office-name">Thessaloniki Office</p>
                  <p>15 Nikiforou Ouranou & Minotavrou Streets</p>
                  <p>Thessaloniki, 54627, PORTO CENTER, Building G1, 3rd Floor</p>
                  <p>Tel: (+30)-231-005-3361</p>
                </div>
                <div className="footer-office">
                  <p className="office-name">Crete Office</p>
                  <p>Kisamos, Chania</p>
                  <p>Tel: (+30)-2822-051309</p>
                </div>
                <p className="footer-email">info@meta-365.com</p>
              </div>
            </div>
            <div className="footer-bottom">
              <p>&copy; 2026 Meta-365. All rights reserved.</p>
              <div className="footer-social">
                <a href="https://www.linkedin.com/company/meta-365" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><img loading="lazy" decoding="async" src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%20fill='white'%3E%3Cpath%20d='M4.98%203.5C4.98%204.88%203.87%206%202.5%206S0%204.88%200%203.5%201.12%201%202.5%201s2.48%201.12%202.48%202.5zM.25%208h4.5v13H.25V8zM8.5%208h4.31v1.78h.06c.6-1.14%202.07-2.34%204.26-2.34C21.5%207.44%2022.5%2010%2022.5%2014.02V21H18v-6.1c0-1.46-.03-3.33-2.03-3.33-2.03%200-2.34%201.58-2.34%203.22V21H8.5V8z'/%3E%3C/svg%3E" alt="LinkedIn" width="18" height="18" /></a>
                <a href="https://www.facebook.com/profile.php?id=61589941284929" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><img loading="lazy" decoding="async" src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%20fill='white'%3E%3Cpath%20d='M24%2012.07C24%205.4%2018.63%200%2012%200S0%205.4%200%2012.07C0%2018.1%204.39%2023.1%2010.13%2024v-8.44H7.08v-3.49h3.05V9.41c0-3.02%201.79-4.69%204.53-4.69%201.31%200%202.68.24%202.68.24v2.97h-1.51c-1.49%200-1.96.93-1.96%201.89v2.25h3.33l-.53%203.49h-2.8V24C19.61%2023.1%2024%2018.1%2024%2012.07z'/%3E%3C/svg%3E" alt="Facebook" width="18" height="18" /></a>
              </div>
              <div className="footer-links">
                <a href="/privacy-policy">Privacy Policy</a>
                <a href="/terms-of-use">Terms & Conditions</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default Schedule;

